import React from "react";
import classes from "./Description.module.scss";
import TextDecoration, { LineElement } from "../text-decoration/TextDecoration";

/**
 * 説明文プロパティ
 */
type DescriptionProps = {
  /** メッセージ */
  message: LineElement[] | undefined;
};

/**
 * 説明文
 * @param props 説明文プロパティ
 */
const Description: React.FC<DescriptionProps> = (props) => {
  return (
    <div className={classes.description}>
      <TextDecoration sentences={props.message}></TextDecoration>
    </div>
  );
};

export default Description;
